import React from "react";
import ProductSelector from "./components/ProductSelector";
import {ReportInputViewProps} from "../types";
import {DashboardButton, DashboardIconButton} from "@/ReactInit/Scripts/DashboardPage/components/DashboardButton";
import {DashboardCard} from "@/ReactInit/Scripts/DashboardPage/components/DashboardCard";
import {getDisabledCategoriesForIndex} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

const ReportInputView: React.FC<ReportInputViewProps> = (
  {
    categoryBlocks,
    updateCategory,
    updateProduct,
    updateVolume,
    updateLastYearVolume,
    setRowErrors,
    addCategoryBlock,
    removeCategoryBlock,
    hasMissingVolume,
    hasRowErrors,
    hasValidProductEntry,
    nextStep,
    onSaveDraft,
    isSavingDraft,
    lastYearVolumesByProduct,
    showEditCancelButton = false,
    editCancelButton,
  }) => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5">
        {categoryBlocks.map((block, i) => {
          const selectedCategories = categoryBlocks.map((b) => b.category);
          const disabledCategories = getDisabledCategoriesForIndex(selectedCategories, i);
          
            return (
              <DashboardCard
                key={block.id}
                className="relative"
              >
                <ProductSelector
                  selectedCategory={block.category}
                  disabledCategories={disabledCategories}
                  products={block.products}
                  volumes={block.volumes}
                  lastYearVolumes={block.lastYearVolumes}
                  onCategoryChange={(category) => updateCategory(i, category)}
                  onProductChange={(rowIndex, product) =>
                    updateProduct(i, rowIndex, product)
                  }
                  onVolumeChange={(rowIndex, volume) =>
                    updateVolume(i, rowIndex, volume)
                  }
                  onLastYearVolumeChange={(rowIndex, value) =>
                    updateLastYearVolume(i, rowIndex, value)
                  }
                  onRowErrorStateChange={(rowIndex, hasError) => {
                    setRowErrors((prev) => {
                      const updated = {...prev};
                      const arr = updated[block.id] ? [...updated[block.id]] : [];
                      arr[rowIndex] = hasError;
                      updated[block.id] = arr;
                      return updated;
                    });
                  }}
                  lastYearVolumesByProduct={lastYearVolumesByProduct}
                />

                {categoryBlocks.length > 1 && (
                  <DashboardIconButton
                    label="Fjern produktkategori"
                    variant="sidebar"
                    rounded="full"
                    size="3"
                    icon="icon-x"
                    onClick={() => removeCategoryBlock(block.id)}
                    className="absolute top-2 right-2"
                  />
                )}
              </DashboardCard>
            )
          }
        )}
        <DashboardButton
          label="Legg til produktkategori"
          variant="sidebar"
          onClick={() => addCategoryBlock()}
          disabled={isSavingDraft}
          icon="icon-circle-plus"
          className="!rounded-[100px] !py-6"
        />
      </div>

      {hasRowErrors && (
        <div className="flex items-center gap-3 px-5 py-3 border border-red-secondary bg-red-25">
          <div
            className="icon-triangle-alert text-red-secondary !text-3xl"
            aria-hidden="true"
          ></div>
          <span className="text-base">
            Du mangler å fylle ut noen obligatoriske felt. Se over og fullfør
            før du avslutter rapporteringen.
          </span>
        </div>
      )}

      <div className="flex flex-col tablet:flex-row justify-center gap-3">
        {showEditCancelButton ? (
          <DashboardButton
            label="Avbryt"
            variant="underline"
            icon="icon-x"
            onClick={editCancelButton}
          />
        ) : (
          <DashboardButton
            label="Lagre utkast"
            variant="underline"
            loadingText="Lagrer…"
            onClick={onSaveDraft}
            icon="icon-save"
            loading={isSavingDraft}
            disabled={isSavingDraft || hasRowErrors}
          />
        )}
        <DashboardButton
          label="Neste"
          variant="darkplain"
          onClick={() => {
            nextStep();
          }}
          icon="icon-arrow-right"
          disabled={isSavingDraft || hasMissingVolume() || hasRowErrors || !hasValidProductEntry()}
        />
      </div>
    </div>
  );
};

export default ReportInputView;
